module.exports = __webpack_public_path__ + "static/media/CeraPro-Medium.561288a6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/CeraPro-Medium.woff2
// module id = 169
// module chunks = 56